<template>
  <div class="sign_view">
    <div class="query_wapper">
      <div class="query_item">
        <el-button-group>
          <el-button
            @click="selectType(1)"
            :class="switchType === 1?'select':'normal'"
            style="width:100px"
          >报名表</el-button>
          <el-button @click="selectType(2)" :class="switchType === 2?'select':'normal'">运动员照片</el-button>
        </el-button-group>
      </div>
      <div class="query_item">
        <el-select
          :popper-append-to-body="false"
          style="width:150px"
          v-model="query.year"
          @change="selectYear"
        >
          <el-option
            v-for="(item,index) in yearLists"
            :value="item.value"
            :label="item.label"
            :key="index"
          ></el-option>
        </el-select>
      </div>
      <div class="query_item">
        <el-select
          :popper-append-to-body="false"
          v-model="query.matchId"
          @change="selectMatch"
          style="width:200px;"
          placeholder="请选择赛事"
        >
          <el-option
            v-for="(item,index) in matchList"
            :key="index"
            :value="item.id"
            :label="item.name"
          ></el-option>
        </el-select>
      </div>
      <div class="query_item">
        <el-select
          :popper-append-to-body="false"
          v-model="query.id"
          placeholder="请选择学校"
          style="width:200px;"
          @change="getSignDetail"
        >
          <el-option
            v-for="(item,index) in schoolList"
            :key="index"
            :value="item.id"
            :label="item.schoolName"
          ></el-option>
        </el-select>
      </div>
      <div class="query_item" v-if="userInfo.project !== 4">
        <el-button type="warning" style="width:90px;margin-right:8px;" @click="print">打印</el-button>
        <el-button type="primary" style="width:90px" v-if="!isOtherBall && userInfo.project !== 9" @click="exportPdf">导出</el-button>
      </div>
    </div>
    <template v-if="details.matchName">
      <main :id="isListPrint?'father':'studentRegist'" v-if="switchType === 1">
        <div style="padding:30px 0 0 0">
          <h1 style="text-align:center;font-weight:normal;">{{details.matchName}}报名表</h1>
          <div class="info">
            <div
              class="info_row"
              style="display: flex;align-items: center;font-size: 18px;color: #444;"
            >
              <section
                style="margin-right: 20px;display: flex;align-items: center;padding:0;margin-top:0;margin-bottom:0;"
              >
                <p
                  class="info_title first_title"
                  style="width: 80px;display: flex;justify-content: space-between;padding:0;margin:0;"
                >
                  <span>校</span>
                  <span>名：</span>
                </p>
                <span class="info_text rights">{{getSchoolName}}</span>
              </section>
              <section style="flex:1;display: flex;align-items: center;padding:0;margin:0;">
                <template v-if="userInfo.project !== 9">
                  <span class="info_title" style="width:60px;">组 别：</span>
                  <span class="info_text">{{details.groupText}}</span>
                </template>
                <template v-else>
                  <span class="info_title" style="width:60px;">团 长：</span>
                  <span class="info_text">{{details.teamLeader}}</span>
                </template>
              </section>
            </div>
            <div
              class="info_row"
              style="display: flex;align-items: center;font-size: 18px;color: #444;"
            >
              <section
                style="display: flex;align-items: center;padding:0;margin-top:0;margin-bottom:0;"
              >
                <p
                  class="info_title first_title"
                  style="width: 80px;display: flex;justify-content: space-between;padding:0;margin:0;"
                >
                  <span>领</span>
                  <span>队：</span>
                </p>
                <span class="info_text" style="width:260px;">{{details.leaderName}}</span>
              </section>
              <section
                style="display: flex;align-items: center;padding:0;margin-top:0;margin-bottom:0;"
              >
                <p
                  class="info_title first_title"
                  style="width:90px;display: flex;justify-content: space-between;padding:0;margin:0;"
                >
                  <span>手</span>
                  <span>机：</span>
                </p>
                <span class="info_text phones" style="width:260px;">{{details.leaderPhone}}</span>
              </section>
              <section style="display: flex;align-items: center;padding:0;margin:0;">
                <span class="info_title" style="width:60px;">邮 箱：</span>
                <span class="info_text" style="width:220px;">{{details.leaderEmail}}</span>
              </section>
            </div>
            <div
              class="info_row"
              style="display: flex;align-items: center;font-size: 18px;color: #444;"
            >
              <section
                style="display: flex;align-items: center;padding:0;margin-top:0;margin-bottom:0;"
              >
                <p
                  class="info_title first_title"
                  style="width: 80px;display: flex;justify-content: space-between;padding:0;margin:0;"
                >
                  <span>主</span>
                  <span>教</span>
                  <span>练：</span>
                </p>
                <span class="info_text" style="width:260px;">{{details.headCoachName}}</span>
              </section>
              <section
                style="display: flex;align-items: center;padding:0;margin-top:0;margin-bottom:0;"
              >
                <p
                  class="info_title first_title"
                  style="width: 90px;display: flex;justify-content: space-between;padding:0;margin:0;"
                >
                  <span>手</span>
                  <span>机：</span>
                </p>
                <span class="info_text phones" style="width:260px;">{{details.headCoachPhone}}</span>
              </section>
              <section style="display: flex;align-items: center;padding:0;margin:0;">
                <span class="info_title" style="width:60px;">邮 箱：</span>
                <span class="info_text" style="width:220px">{{details.headCoachEmail}}</span>
              </section>
            </div>
            <div
              class="info_row"
              style="display: flex;align-items: center;font-size: 18px;color: #444;"
            >
              <section
                style="display: flex;align-items: center;padding:0;margin-top:0;margin-bottom:0;"
              >
                <p
                  class="info_title first_title"
                  style="width: 80px;display: flex;justify-content: space-between;padding:0;margin:0;"
                >
                  <span>教</span>
                  <span>练：</span>
                </p>
                <span class="info_text" style="min-width:260px;">{{details.coachNames}}</span>
              </section>
              <section
                tyle="display: flex;align-items: center;padding:0;margin-top:0;margin-bottom:0;"
              >
                <span class="info_title" style="width:90px">工作人员：</span>
                <span class="info_text" style="width:260px">{{details.workerNames}}</span>
              </section>
              <section
                v-if="isOtherBall"
                style="display: flex;align-items: center;padding:0;margin:0;"
              >
                <span class="info_title" style="width:60px;">住 宿：</span>
                <span
                  class="info_text"
                  style="width:220px;"
                >男 {{details.stayMan}}，女 {{details.stayWoman}}（人）</span>
              </section>
            </div>
          </div>
          <div class="table_list">
            <template v-if="userInfo.project !== 7 && userInfo.project !== 9 && !isOtherBall">
              <table
                cellpadding="0"
                cellspacing="0"
                v-for="(item,index) in getTableList"
                :key="item"
                style="color:#000;"
                :class="(index + 1) % 4 === 0?'page_break':''"
                :style="{pageBreakAfter:(index + 1) % 3 === 0 || (getTableList < 3 && (index+1) === getTableList)?'always':'',fontSize:!isShowBorder?'16px':''}"
              >
                <tbody>
                  <tr v-for="(temp,num) in columns" :key="index + '_' + num">
                    <td
                      :style="{borderRight:'none',borderBottom:num === (columns.length - 1)?'1px solid #222':'none'}"
                      style="border:1px solid #222;
                padding: 12px 0;
                min-width: 0;
                box-sizing: border-box;
                text-overflow: ellipsis;
                vertical-align: middle;
                position: relative;
                text-align: center;color:#000;"
                    >
                      <div
                        style="box-sizing: border-box;
                    overflow: hidden;
                    width:100px;
                    text-overflow: ellipsis;
                    white-space: normal;
                    word-break: break-all;
                    line-height: 23px;
                    padding-left: 10px;
                    padding-right: 10px;color:#000;"
                      >{{temp.name}}</div>
                    </td>
                    <template v-for="(i,n) in details.athleteList.slice(index * 5,(index + 1) * 5)">
                      <td
                        :style="{borderRight:n === 4?'1px solid #000':'none',borderBottom:num === (columns.length - 1)?'1px solid #222':'none'}"
                        style="border:1px solid #222;padding: 12px 0;
                min-width: 0;
                width:240px;
                box-sizing: border-box;
                text-overflow: ellipsis;
                vertical-align: middle;
                position: relative;
                text-align: center;color:#000"
                        :key="index + '_' + num + n"
                      >
                        <div
                          style="box-sizing: border-box;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: normal;
                    word-break: break-all;
                    line-height: 23px;
                    padding-left: 10px;
                    padding-right: 10px;color:#000"
                        >{{temp.key === 'heightAndWeight'?(!i['height'] && !i['weight'])?'':(i['height'] + 'cm/' + i['weight'] + 'kg'):temp.key === 'startSchoolDate'?(!i[temp.key]?'':formatTime(i[temp.key])):i[temp.key]}}</div>
                      </td>
                    </template>
                  </tr>
                </tbody>
              </table>
            </template>
            <!-- 网球、羽毛球、乒乓球 -->
            <template v-else-if="isOtherBall">
              <table
                cellpadding="0"
                cellspacing="0"
                style="margin-bottom:20px;width:100%;color:#000"
                class="foot_table"
              >
                <thead>
                  <th>序号</th>
                  <th>姓名</th>
                  <th>性别</th>
                  <th>民族</th>
                  <th>学号</th>
                  <th>入学时间</th>
                  <th>注册号码</th>
                  <th>电话号码</th>
                  <th>团体</th>
                  <th>男单</th>
                  <th>女单</th>
                  <th>男双</th>
                  <th>女双</th>
                  <th>混双</th>
                </thead>
                <tbody>
                  <tr v-for="(temp,num) in tableData.athleteList" :key="num">
                    <td style="width:60px;">
                      <div>{{num+1}}</div>
                    </td>
                    <td style="width:100px">
                      <div>{{temp.athleteName}}</div>
                    </td>
                    <td style="width:60px">
                      <div>{{temp.genderText}}</div>
                    </td>
                    <td style="width:80px">
                      <div>{{temp.nation}}</div>
                    </td>
                    <td style="width:100px">
                      <div>{{temp.studentNumber}}</div>
                    </td>
                    <td style="width:100px">
                      <div>{{formatTime(temp.startSchoolDate)}}</div>
                    </td>
                    <td style="width:120px">
                      <div>{{temp.registerNumber}}</div>
                    </td>
                    <td style="width:120px">
                      <div>{{temp.athletePhone}}</div>
                    </td>
                    <td style="width:70px">
                      <div>{{temp.projectJson.smallBallGroup}}</div>
                    </td>
                    <td style="width:70px">
                      <div>{{temp.projectJson.smallBallSingles1}}</div>
                    </td>
                    <td style="width:70px">
                      <div>{{temp.projectJson.smallBallSingles0}}</div>
                    </td>
                    <td style="width:70px">
                      <div>{{temp.projectJson.smallBallDoubles1}}</div>
                    </td>
                    <td style="width:70px">
                      <div>{{temp.projectJson.smallBallDoubles0}}</div>
                    </td>
                    <td style="width:70px">
                      <div>{{temp.projectJson.smallBallMixed}}</div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </template>
            <!-- 田径 -->
            <template v-else-if="userInfo.project === 9">
              <table style="margin-bottom:20px;width:100%;" class="foot_table">
                <thead>
                  <th>序号</th>
                  <th>组别</th>
                  <th>性别</th>
                  <th>姓名</th>
                  <th>注册号码</th>
                  <th>
                    <p style="margin-bottom:4px">项目一</p>
                    <p>（单项）</p>
                  </th>
                  <th>
                    <p style="margin-bottom:4px">项目二</p>
                    <p>（单项）</p>
                  </th>
                  <th>
                    <p>项目三</p>
                    <p>（接力）</p>
                  </th>
                  <th>
                    <p>项目四</p>
                    <p>（接力）</p>
                  </th>
                  <th>教练员</th>
                  <th
                    style="border:1px solid #222;padding: 12px 0;min-width: 0; box-sizing: border-box;text-overflow: ellipsis;vertical-align: middle;position: relative;text-align: center;"
                  >备注</th>
                </thead>
                <tbody>
                  <tr v-for="(temp,num) in tableData.athleteList" :key="num">
                    <td style="width:60px;">
                      <div>{{num+1}}</div>
                    </td>
                    <td style="width:60px">
                      <div>{{temp.projectJson.athleticsGroup}}</div>
                    </td>
                    <td style="width:60px">
                      <div>{{temp.genderText}}</div>
                    </td>
                    <td style="width:100px">
                      <div>{{temp.athleteName}}</div>
                    </td>
                    <td style="width:120px">
                      <div>{{temp.registerNumber}}</div>
                    </td>
                    <td style="width:90px">
                      <div>{{temp.projectJson.athleticsIndividual1}}</div>
                    </td>
                    <td style="width:90px">
                      <div>{{temp.projectJson.athleticsIndividual2}}</div>
                    </td>
                    <td style="width:108px">
                      <div>{{temp.projectJson.athleticsRelay1}}</div>
                    </td>
                    <td style="width:108px">
                      <div>{{temp.projectJson.athleticsRelay2}}</div>
                    </td>
                    <td style="width:100px">
                      <div>{{temp.coachName}}</div>
                    </td>
                    <td>
                      <div>{{temp.remarks}}</div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </template>
            <!-- 足球 -->
            <template v-else>
              <table class="foot_table" style="width:100%;margin-bottom:20px;color:#000">
                <thead>
                  <th>序号</th>
                  <th>姓名</th>
                  <th>入学时间</th>
                  <th>号码</th>
                  <th>位置</th>
                  <th>队员注册号</th>
                  <th>入学性质</th>
                  <th
                    style="border:1px solid #222;padding: 12px 0;min-width: 0; box-sizing: border-box;text-overflow: ellipsis;vertical-align: middle;position: relative;text-align: center;"
                  >备注</th>
                </thead>
                <tbody>
                  <template v-for="(i) in 26">
                    <tr v-if="i < 21" :key="i">
                      <td style="width:60px">
                        <div>{{i}}</div>
                      </td>
                      <td style="width:150px;">
                        <div>{{details.athleteList[i-1]?details.athleteList[i-1].athleteName:''}}</div>
                      </td>
                      <td style="width:120px;">
                        <div>{{details.athleteList[i-1].startSchoolDate?formatTime(details.athleteList[i-1].startSchoolDate):''}}</div>
                      </td>
                      <td style="width:100px;">
                        <div>{{details.athleteList[i-1]?details.athleteList[i-1].signNumber:''}}</div>
                      </td>
                      <td style="width:100px;">
                        <div>{{details.athleteList[i-1]?details.athleteList[i-1].position:''}}</div>
                      </td>
                      <td style="width:200px;">
                        <div>{{details.athleteList[i-1]?details.athleteList[i-1].registerNumber:''}}</div>
                      </td>
                      <td style="width:100px;">
                        <div>{{details.athleteList[i-1]?details.athleteList[i-1].sportsLevelText:''}}</div>
                      </td>
                      <td>
                        <div>{{details.athleteList[i-1]?details.athleteList[i-1].remarks:''}}</div>
                      </td>
                    </tr>
                    <tr v-else-if="i === 21" :key="i + '_'">
                      <td colspan="8">
                        <div>以上20人为赛区确认名单，以下5人为递补名单。</div>
                      </td>
                    </tr>
                    <tr v-else :key="i + '-'">
                      <td style="width:60px">
                        <div>{{i - 1}}</div>
                      </td>
                      <td style="width:150px;">
                        <div>{{details.athleteBenchList[i-22]?details.athleteBenchList[i-22].athleteName:''}}</div>
                      </td>
                      <td style="width:120px;">
                        <div>{{details.athleteBenchList[i-22]?formatTime(details.athleteBenchList[i-22].startSchoolDate):''}}</div>
                      </td>
                      <td style="width:100px;">
                        <div>{{details.athleteBenchList[i-22]?details.athleteBenchList[i-22].signNumber:''}}</div>
                      </td>
                      <td style="width:100px;">
                        <div>{{details.athleteBenchList[i-22]?details.athleteBenchList[i-22].position:''}}</div>
                      </td>
                      <td style="width:200px;">
                        <div>{{details.athleteBenchList[i-22]?details.athleteBenchList[i-22].registerNumber:''}}</div>
                      </td>
                      <td style="width:100px;">
                        <div>{{details.athleteBenchList[i-22]?details.athleteBenchList[i-22].sportsLevelText:''}}</div>
                      </td>
                      <td>
                        <div>{{details.athleteBenchList[i-22]?details.athleteBenchList[i-22].remarks:''}}</div>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </template>
            <template v-if="isShowBottom">
              <div
                class="foots"
                v-if="details.state === 0"
                :class="getTableList % 3 === 0?'page_break':''"
                style="height:200px;color:#444;padding:20px;border:1px solid #222;margin-bottom:20px"
              >
                <section
                  style="font-size:24px;display:flex;height:100%;flex-direction:column;align-items:center;justify-content:center"
                >
                  <p>报名未提交</p>
                </section>
              </div>
              <div
                class="foots"
                v-else
                :class="getTableList % 3 === 0?'page_break':''"
                style="height:200px;color:#444;padding:20px;border:1px solid #222;margin-bottom:20px"
              >
                <p style="font-size:20px;">体育部意见：</p>
                <p
                  style="font-size:24px;text-align:center;margin-top:50px;"
                >{{details.state === 1?'待审核':details.state === 2?'已驳回':'同意'}}</p>
              </div>
            </template>
          </div>
        </div>
        <athletesPhoto
          v-if="!isShowBottom"
          ref="athletesPhoto"
          :details="tableData"
          :matchName="matchName"
        ></athletesPhoto>
      </main>
      <template v-else>
        <athletesPhoto v-if="userInfo.project !== 9 && !isOtherBall" ref="athletesPhoto" :details="tableData" :matchName="matchName"></athletesPhoto>
        <smallBallPhoto v-else-if="isOtherBall" ref="athletesPhoto" :details="tableData" :matchName="matchName"></smallBallPhoto>
        <athleticsPhoto v-else ref="athletesPhoto" :details="tableData" :matchName="matchName"></athleticsPhoto>
      </template>
    </template>
    <template v-else>
      <main v-if="switchType === 1">
        <div :id="isListPrint?'father':'studentRegist'" style="padding:30px 0 0 0">
          <h1 style="text-align:center;font-weight:normal;">{{getMatchName}}报名表</h1>
          <div class="info">
            <div
              class="info_row"
              style="display: flex;align-items: center;font-size: 18px;color: #444;"
            >
              <section
                style="margin-right: 20px;display: flex;align-items: center;padding:0;margin-top:0;margin-bottom:0;"
              >
                <p
                  class="info_title first_title"
                  style="width: 80px;display: flex;justify-content: space-between;padding:0;margin:0;"
                >
                  <span>校</span>
                  <span>名：</span>
                </p>
                <span class="info_text" style="width:630px;"></span>
              </section>
              <section
                style="margin-right: 20px;display: flex;align-items: center;padding:0;margin-top:0;margin-bottom:0;"
              >
                <span class="info_title">组 别：</span>
                <span class="info_text"></span>
              </section>
            </div>
            <div
              class="info_row"
              style="display: flex;align-items: center;font-size: 18px;color: #444;"
            >
              <section
                style="margin-right: 20px;display: flex;align-items: center;padding:0;margin-top:0;margin-bottom:0;"
              >
                <p
                  class="info_title first_title"
                  style="width: 80px;display: flex;justify-content: space-between;padding:0;margin:0;"
                >
                  <span>领</span>
                  <span>队：</span>
                </p>
                <span class="info_text" style="width:260px;"></span>
              </section>
              <section
                style="margin-right: 20px;display: flex;align-items: center;padding:0;margin-top:0;margin-bottom:0;"
              >
                <p
                  class="info_title first_title"
                  style="width: 90px;display: flex;justify-content: space-between;padding:0;margin:0;"
                >
                  <span>手</span>
                  <span>机：</span>
                </p>
                <span class="info_text phones" style="width:260px;"></span>
              </section>
              <section
                style="margin-right: 20px;display: flex;align-items: center;padding:0;margin-top:0;margin-bottom:0;"
              >
                <span class="info_title">邮 箱：</span>
                <span class="info_text"></span>
              </section>
            </div>
            <div
              class="info_row"
              style="display: flex;align-items: center;font-size: 18px;color: #444;"
            >
              <section
                style="margin-right: 20px;display: flex;align-items: center;padding:0;margin-top:0;margin-bottom:0;"
              >
                <p
                  class="info_title first_title"
                  style="width: 80px;display: flex;justify-content: space-between;padding:0;margin:0;"
                >
                  <span>主</span>
                  <span>教</span>
                  <span>练：</span>
                </p>
                <span class="info_text" style="width:260px;"></span>
              </section>
              <section
                style="margin-right: 20px;display: flex;align-items: center;padding:0;margin-top:0;margin-bottom:0;"
              >
                <p
                  class="info_title first_title"
                  style="width: 90px;display: flex;justify-content: space-between;padding:0;margin:0;"
                >
                  <span>手</span>
                  <span>机：</span>
                </p>
                <span class="info_text phones" style="width:260px;"></span>
              </section>
              <section
                style="margin-right: 20px;display: flex;align-items: center;padding:0;margin-top:0;margin-bottom:0;"
              >
                <span class="info_title">邮 箱：</span>
                <span class="info_text"></span>
              </section>
            </div>
            <div
              class="info_row"
              style="display: flex;align-items: center;font-size: 18px;color: #444;"
            >
              <section
                style="margin-right: 20px;display: flex;align-items: center;padding:0;margin-top:0;margin-bottom:0;"
              >
                <p
                  class="info_title first_title"
                  style="width: 80px;display: flex;justify-content: space-between;padding:0;margin:0;"
                >
                  <span>教</span>
                  <span>练：</span>
                </p>
                <span class="info_text" style="min-width:260px;"></span>
              </section>
              <section
                style="margin-right: 20px;display: flex;align-items: center;padding:0;margin-top:0;margin-bottom:0;"
              >
                <span class="info_title" style="width:90px">工作人员：</span>
                <span class="info_text" style="min-width:120px"></span>
              </section>
            </div>
          </div>
          <div class="table_list">
            <div
              style="height:200px;color:#444;padding:20px;border:1px solid #222;margin-bottom:20px"
            >
              <section
                style="font-size:24px;display:flex;height:100%;
            flex-direction:column;align-items:center;justify-content:center"
              >
                <p>暂无数据</p>
              </section>
            </div>
          </div>
        </div>
      </main>
      <athletesPhoto v-else :details="tableData" :matchName="matchName"></athletesPhoto>
    </template>
  </div>
</template>
<script>
import { getSession } from "@/utils/storage";
import { signDetail, signList } from "@/api/sign-up-match";
import { method } from "@/utils/utils";
import athletesPhoto from "./athletes-photo";
import athleticsPhoto from "@/components/athletics-photo";
import smallBallPhoto from "@/components/smallBall-photo";
import { getMatchList } from "@/api/sports-management";
import html2Canvas from "html2canvas";
import JsPDF from "jspdf";
import { message, selectiveYear } from "@/common/js/mixins";
export default {
  // 报名表查看
  components: {
    athletesPhoto,athleticsPhoto,smallBallPhoto
  },
  mixins: [message, selectiveYear],
  props: {
    info: {
      type: Object
    },
    isListPrint: {
      type: Boolean
    }
  },
  data() {
    return {
      isShowBottom: true,
      loading: null,
      isShowBorder: true,
      isRender: false,
      matchList: [],
      switchType: 1,
      matchName: "",
      schoolList: [],
      details: {},
      tableData: {},
      userInfo: JSON.parse(getSession("userInfo")) || "",
      query: {
        year: "",
        id: "",
        matchId: ""
      },
      columns: [
        {
          key: "signNumber",
          name: "号码"
        },
        { key: "position", name: "位置" },
        { key: "athleteName", name: "姓名" },
        { key: "studentNumber", name: "学号" },
        { key: "startSchoolDate", name: "入学时间" },
        { key: "heightAndWeight", name: "身高、体重" },
        { key: "registerNumber", name: "队员注册号" }
      ]
    };
  },
  computed: {
    // 网球、羽毛球、乒乓球公用
    isOtherBall() {
      return (
        this.userInfo.project === 1 ||
        this.userInfo.project === 5 ||
        this.userInfo.project === 6
      );
    },
    // 获取学校名称
    getSchoolName() {
      let str = "";
      this.schoolList.filter(item => {
        if (item.id === this.query.id) str = item.schoolName;
      });
      return str;
    },
    // 获取赛事名称
    getMatchName() {
      let str = "";
      this.matchList.filter(item => {
        if (item.id === this.query.matchId) {
          str = item.name;
          this.matchName = item.name;
        }
      });
      return str;
    },
    // 表格显示数量
    getTableList() {
      if (this.userInfo.project === 7) {
        return;
      }
      /**
       * 每个表格显示5项数据，如果数据小于5条，则使用空对象填充
       */
      let num = 0;

      if (this.details.athleteList && this.details.athleteList.length < 5) {
        let length = 5 - this.details.athleteList.length;
        for (let i = 0; i < length; i++) {
          this.details.athleteList.push({});
        }

        num = 1;
      } else if (
        /**
         * 数据大于5或等于5条时，则计算表格展示数量，并判断最后一个表格数据<5条时 使用空数据填充
         */
        this.details.athleteList &&
        this.details.athleteList.length >= 5
      ) {
        let length = this.details.athleteList.length;
        if (length / 5 > parseInt(length / 5)) {
          num = parseInt(length / 5) + 1;
        } else {
          num = length / 5;
        }
        if (this.details.athleteList.slice((num - 1) * 5, num * 5).length < 5) {
          let length =
            5 - this.details.athleteList.slice((num - 1) * 5, num * 5).length;
          for (let i = 0; i < length; i++) {
            this.details.athleteList.push({});
          }
        }
      }
      return num;
    },
    formatTime() {
      return data => {
        return method.timeFormat(data);
      };
    }
  },
  watch: {
    info: {
      handler(value) {
        if (value) {
          this.switchType = 1;
          Object.assign(this.query, {
            year: value.year,
            matchId: value.matchId,
            id: value.id
          });
          this.getMatch();
        }
      },
      deep: true
    }
  },
  methods: {
    // 导出pdf
    exportPdf() {
      if (this.schoolList.length === 0) {
        return this.openWarn("当前赛事暂无数据导出");
      }
      this.$parent.$parent.makePdf(this.query.id);
      // var that = this;
      // document.documentElement.scrollLeft = 0;
      // this.loading = this.$loading({
      //   lock: false,
      //   text: "PDF生成中...",
      //   spinner: "el-icon-loading"
      // });
      // that.isShowBottom = false;
      // that.isShowBorder = false;

      // this.$nextTick(() => {
      //   html2Canvas(
      //     document.querySelector(
      //       this.isListPrint ? "#father" : "#studentRegist"
      //     ),
      //     {
      //       allowTaint: true,
      //       dpi: 192
      //     }
      //   ).then(canvas => {
      //     let contentWidth = canvas.width;
      //     let contentHeight = canvas.height;
      //     let pageHeight = (contentWidth / 592.28) * 841.89;
      //     let leftHeight = contentHeight;
      //     let position = 0;
      //     let pageData = canvas.toDataURL("image/jpeg", 1.0);
      //     var pdfX = ((contentWidth + 10) / 2) * 0.75;
      //     var pdfY = ((contentHeight + 200) / 2) * 0.75;
      //     var imgX = 594;
      //     var imgY = (contentHeight / 2) * 1.15;
      //     var difference = imgY - pdfY > 0 ? imgY - pdfY : 0;
      //     let PDF = null;
      //     if (this.getShowTableNum() <= 1) {
      //       PDF = new JsPDF("", "pt", "a4");
      //     } else {
      //       PDF = new JsPDF("", "pt", [592.28, pdfY + difference + 30]);
      //     }
      //     // var imgY = (592.28 / contentWidth) * contentHeight; //内容图片这里不需要留白的距离
      //     PDF.addImage(pageData, "JPEG", 0, position, imgX, imgY);
      //     PDF.save(that.details.matchName + ".pdf");
      //     that.loading.close();
      //     that.isShowBorder = true;
      //     that.isShowBottom = true;
      //   });
      // });
    },
    //
    getShowTableNum() {
      let num = 0;
      if (this.details.athleteList && this.details.athleteList.length < 5) {
        let length = 5 - this.details.athleteList.length;
        for (let i = 0; i < length; i++) {
          this.details.athleteList.push({});
        }

        num = 1;
      } else if (
        /**
         * 数据大于5或等于5条时，则计算表格展示数量，并判断最后一个表格数据<5条时 使用空数据填充
         */
        this.details.athleteList &&
        this.details.athleteList.length >= 5
      ) {
        let length = this.details.athleteList.length;
        if (length / 5 > parseInt(length / 5)) {
          num = parseInt(length / 5) + 1;
        } else {
          num = length / 5;
        }
        if (this.details.athleteList.slice((num - 1) * 5, num * 5).length < 5) {
          let length =
            5 - this.details.athleteList.slice((num - 1) * 5, num * 5).length;
          for (let i = 0; i < length; i++) {
            this.details.athleteList.push({});
          }
        }
      }
      return num;
    },
    // 打印
    print() {
      if (this.schoolList.length === 0) {
        return this.openWarn("当前赛事暂无数据打印");
      }
      // if (this.switchType === 2) {
      this.$parent.$parent.makePrint(this.query.id);
      // return;
      // }
      // this.isShowBottom = false;
      // let timer = setInterval(() => {
      //   if (this.$refs.athletesPhoto.isRenders) {
      //     clearInterval(timer);
      //     this.$nextTick(() => {
      //       var el = document.querySelector("#studentRegist"),
      //         iframe = document.createElement("IFRAME"),
      //         doc = null;
      //       iframe.setAttribute("id", "print-iframe");
      //       iframe.setAttribute(
      //         "style",
      //         "width:100%;font-size:20px;text-align:center"
      //       );
      //       document.body.appendChild(iframe);
      //       doc = iframe.contentWindow.document;
      //       doc.write(
      //         '<html><head><style type="text/css" media="print">ul{list-style:none} @page {size: auto; margin: 0mm 10mm;} .margin_top {margin-top:20mm!important} .top_border {border-top:1px solid #999!important} .left_border {border-left:1px solid #999!important} .bottom_border {border-bottom:1px solid #999!important} .right_border {border-right:1px solid #999!important;} .athletes_photo {margin-top:15mm;border:none!important} .headers{margin-top:5mm;padding-top:0!important} .fonts_color {color:#000} .athlete_info {font-size:16px!important;margin-bottom:6px!important} .info_text {word-break:break-all} .page_break {margin-top:15mm!important} .phones {width:230px!important} .info_row {margin:0 0 15px 0} .foots {margin-top:20px} .info {margin-bottom:20px} table {margin-top:30px;color:#000} table tr td {padding:8px 0!important} main {margin:15mm 0} h1 { margin:5mm 0 40px 0 } span.rights {width:560px}</style></head><body style="zoom: 80%;">' +
      //           el.innerHTML +
      //           "</body></html>"
      //       );
      //       doc.close();
      //       iframe.contentWindow.focus();
      //       iframe.contentWindow.print();
      //       document.body.removeChild(iframe);
      //       this.isShowBottom = true;
      //     });
      //   }
      // }, 300);
    },
    // 选择年份
    selectYear() {
      this.query.matchId = "";
      this.query.id = "";
      this.matchList = [];
      this.schoolList = [];
      this.details = {};
      this.tableData = {};
      this.getMatch();
    },
    // 获取赛事
    getMatch() {
      getMatchList({
        project: this.userInfo.project,
        year: this.query.year,
        pageNo: 1,
        pageSize: 999
      })
        .then(res => {
          this.matchList = [];
          if (res.list.length > 0) {
            this.matchList = res.list;
          }
          this.getList();
        })
        .catch(err => {});
    },
    // 选择赛事
    selectMatch(value) {
      this.query.id = "";
      this.schoolList = [];
      this.details = {};
      this.tableData = {};
      this.matchList.filter(item => {
        if (item.id === value) {
          this.matchName = item.name;
        }
      });
      this.getList();
    },
    // 列表数据
    getList() {
      signList({
        ...this.query,
        pageNo: 1,
        pageSize: 999
      })
        .then(res => {
          this.schoolList = res.list;
          if (this.query.id) this.getSignDetail(this.query.id);
        })
        .catch(err => {});
    },
    // 获取详情数据
    getSignDetail(id = this.query.id) {
      signDetail({ id })
        .then(res => {
          if (this.userInfo.project === 7) {
            let arr = [];
            let newArr = [];
            for (let i = 0; i < 25; i++) {
              if (i < 20) {
                arr.push(res.athleteList[i] ? res.athleteList[i] : {});
              } else {
                arr.push(
                  res.athleteBenchList[i - 20]
                    ? res.athleteBenchList[i - 20]
                    : {}
                );
              }
            }
            newArr = [...res.athleteList, ...res.athleteBenchList];
            let length = newArr.length;
            for (let i = 0; i < 25 - length; i++) {
              newArr.push({});
            }
            res.athletePhotoList = newArr;
            res.athleteList = arr;
          }
          this.details = res;
          this.tableData = JSON.parse(JSON.stringify(res));
          this.isRender = true;
        })
        .catch(err => {});
    },
    // 切换按钮组
    selectType(type) {
      this.switchType = type;
    }
  },
  mounted() {
    this.getYearLists(this.query);
  }
};
</script>
<style lang="less" scoped>
.sign_view {
  > .query_wapper {
    margin: 0 0 0 10px;
  }
  .select {
    background: #1e63b0;
    color: #fff;
  }
  .normal {
    background: transparent;
    color: #999;
  }
  > main {
    width: 1050px;
    border: 1px solid #ddd;
    margin: 0 auto;
    h1 {
      font-size: 24px;
      color: #444;
      text-align: center;
    }
    .foot_table {
      thead th {
        border: 1px solid #222;
        padding: 8px 0;
        min-width: 0;
        box-sizing: border-box;
        text-overflow: ellipsis;
        vertical-align: middle;
        position: relative;
        text-align: center;
      }
      tbody {
        td {
          border: 1px solid #222;
          padding: 6px 0;
          min-width: 0;
          box-sizing: border-box;
          text-overflow: ellipsis;
          vertical-align: middle;
          position: relative;
          text-align: center;
          div {
            box-sizing: border-box;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: normal;
            word-break: break-all;
            line-height: 23px;
            padding-left: 10px;
            padding-right: 10px;
          }
        }
      }
    }
    .info {
      margin: 40px 0;
      padding: 0 20px;
      > div {
        display: flex;
        align-items: center;
        font-size: 18px;
        color: #444;
        margin-bottom: 20px;
        .rights {
          width: 630px;
        }
        > section {
          margin-right: 20px;
          display: flex;
          align-items: center;
          > .first_title {
            width: 80px;
            display: flex;
            justify-content: space-between;
          }
          > .info_text {
            font-size: 18px;
          }
        }
      }
    }
    .table_list {
      padding: 0 20px;
      > table {
        margin-bottom: 20px;
      }
    }
  }
}
</style>